import { Bot, Sparkles } from "lucide-react";
import { Button } from "@ncoder/ui";

interface ModerniseHeaderProps {
  selectedTools: any[];
  onAnalyze?: () => void;
}

export const ModerniseHeader: React.FC<ModerniseHeaderProps> = ({
  selectedTools,
  onAnalyze,
}) => {
  return (
    <div className="flex items-center justify-between mb-8">
      <div className="space-y-2">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
            <Sparkles className="h-5 w-5 text-white" />
          </div>
          <div>
            <h1 className="text-3xl font-bold">Modernise with AI</h1>
            <p className="text-muted-foreground">
              Transform your Salesforce org with AI-powered modernization tools
            </p>
          </div>
        </div>
      </div>

      {selectedTools.length > 0 && (
        <Button
          onClick={onAnalyze}
          className="bg-gradient-to-r from-blue-500 to-purple-600"
        >
          <Bot className="h-4 w-4 mr-2" />
          Analyze Selected ({selectedTools.length})
        </Button>
      )}
    </div>
  );
};
